import { render, staticRenderFns } from "./DemoStudent.vue?vue&type=template&id=3bac80c7&scoped=true&"
import script from "./DemoStudent.vue?vue&type=script&lang=ts&"
export * from "./DemoStudent.vue?vue&type=script&lang=ts&"
import style0 from "./DemoStudent.vue?vue&type=style&index=0&id=3bac80c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bac80c7",
  null
  
)

export default component.exports